(function () {
  if (window.__pvUpsellInit) return;
  window.__pvUpsellInit = true;

  // Horizon (ott 2026) ascolta StandardEvents.cartLinesUpdate da '@shopify/events':
  // il vecchio CustomEvent 'cart:update' non aggiorna più drawer e contatore.
  var eventsModule = null;
  function loadEvents() {
    if (!eventsModule) {
      eventsModule = import('@shopify/events').catch(function () {
        return null;
      });
    }
    return eventsModule;
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.pv-upsell-add') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = '…';

    try {
      var sectionIds = Array.prototype.map
        .call(document.querySelectorAll('cart-items-component'), function (el) {
          return el.dataset.sectionId;
        })
        .filter(Boolean);

      var fd = new FormData();
      fd.set('id', btn.dataset.variantId);
      fd.set('quantity', '1');
      if (sectionIds.length) fd.set('sections', sectionIds.join(','));

      var events = await loadEvents();
      var LinesEvent = events && events.CartLinesUpdateEvent;
      var deferred = LinesEvent ? LinesEvent.createPromise() : null;

      if (LinesEvent) {
        document.dispatchEvent(
          new LinesEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: btn.dataset.variantId, quantity: 1 }],
            promise: deferred.promise
          })
        );
      }

      var addUrl = ((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add') + '.js';
      var res = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      });
      var data = await res.json();

      var cart = await fetch('/cart.js').then(function (r) {
        return r.json();
      });

      if (data.status) {
        if (deferred) {
          deferred.resolve({
            cart: LinesEvent.createCartFromAjaxResponse(cart),
            detail: { didError: true, items: cart.items, source: 'pv-upsell', sourceId: 'pv-upsell', itemCount: 1 }
          });
        }
        btn.disabled = false;
        btn.textContent = '+';
        return;
      }

      if (!sectionIds.length || !LinesEvent) {
        window.location.reload();
        return;
      }

      deferred.resolve({
        cart: LinesEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'pv-upsell',
          sourceId: 'pv-upsell',
          itemCount: 1,
          sections: data.sections,
          didError: false
        }
      });
    } catch (err) {
      console.error('pv-upsell', err);
      window.location.reload();
    }
  });
})();
